"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Base_1 = __importDefault(require("./Base"));
const constants_1 = require("./constants");
const constants_2 = require("./constants");
const payload_1 = require("../utils/payload");
const core_1 = require("../utils/core");
const { get, set, every, isArray, pick } = require("lodash");
class Module extends Base_1.default {
    constructor(data) {
        var _a, _b;
        const pollInherited = pick(data, ["metadata.strings"]);
        super({});
        this.title = '';
        this.motives = [];
        this.score_type = null;
        this.index = -1;
        this.type = "module";
        this.metadata = {};
        this.language = "en";
        data.nombre = data.name || data.nombre || '';
        data.title = data.name || data.nombre || '';
        this.selfMerge(constants_2.moduleDefaults.base);
        // @ts-ignore
        this.selfMerge(constants_2.moduleDefaults[data.score_type]);
        this.selfMerge(pollInherited);
        this.selfMerge(data);
        this.title = data.name || data.nombre;
        this.poll = data.poll;
        this.language = (_b = (_a = this.poll) === null || _a === void 0 ? void 0 : _a.language) !== null && _b !== void 0 ? _b : this.language;
        this.motives = (this.motives || []);
        if (this.motives.length <= 1)
            this.motives = [];
        // RANDOM MOTIVES
        if (this.metadata.settings.randomMotives)
            this.motives = (0, core_1.shuffleMotives)(this.motives);
    }
    /**
     * Mappings
     */
    get strings() {
        return this.metadata.strings;
    }
    get maxMotivos() {
        return this.metadata.settings.maxMotivos;
    }
    get max() {
        const maxDefaultPath = 'metadata.settings.score.max';
        return get(this, maxDefaultPath, get(constants_2.moduleDefaults, `${get(this, 'score_type', 'base')}.${maxDefaultPath}`));
    }
    get min() {
        const minDefaultPath = 'metadata.settings.score.min';
        return get(this, minDefaultPath, get(constants_2.moduleDefaults, `${get(this, 'score_type', 'base')}.${minDefaultPath}`));
    }
    get isBreaker() {
        return this.metadata.settings.break;
    }
    get isRequired() {
        return this.metadata.settings.required;
    }
    getDescription() {
        return this.metadata.settings.description;
    }
    hasMotivesAnswered(responses) {
        const response = responses[this.index];
        return get(response, "motives", []).length > 0;
    }
    hasMotives() {
        return this.motives.length > 1;
    }
    getNext(answers) {
        var _a, _b, _c, _d;
        const { rules } = this.metadata.settings;
        const { min, max, score_type } = this;
        const answer = answers[this.index];
        const nextItem = (_a = this.poll) === null || _a === void 0 ? void 0 : _a.getNextTo(this);
        let nextId = rules.reduce((reduced, { goto, conditions = [] }) => {
            if (reduced !== undefined)
                return reduced;
            if (!conditions.length)
                return goto;
            const evaluation = conditions.map((condition) => {
                const { type, value, operator } = condition;
                const convertedValue = isArray(value)
                    ? [
                        ((value[0] - min) * 9) / (max - min) + 1,
                        ((value[1] - min) * 9) / (max - min) + 1,
                    ]
                    : ((value - min) * 9) / (max - min) + 1;
                if (type === "motives") {
                    const evaluated = (0, payload_1.evalCondition)(get(answer, "motives[0].id"), operator, value);
                    return evaluated === undefined ? "NOT_EVALUATED" : evaluated;
                }
                if (type === "score") {
                    const evaluated = (() => {
                        if (score_type === "numeric") {
                            return (0, payload_1.evalCondition)(get(answer, "score"), operator, value != null ? convertedValue : value);
                        }
                        return (0, payload_1.evalCondition)(get(answer, "score"), operator, value);
                    })();
                    return evaluated === undefined ? "NOT_EVALUATED" : evaluated;
                }
                return true;
            });
            if (evaluation.includes("NOT_EVALUATED"))
                return "NOT_EVALUATED";
            return every(evaluation) ? goto : undefined; //goto is default next question id
        }, undefined);
        if (nextId === "end")
            return {
                error: "END",
                isLast: true,
            };
        if (!this.isRequired && nextItem && get(nextItem, "type") !== "thanks") {
            const item = nextId && nextId !== "NOT_EVALUATED"
                ? (_b = this.poll) === null || _b === void 0 ? void 0 : _b.sortedQuestions.find((item) => item.matchId(nextId))
                : nextItem;
            return {
                nextItem: item,
            };
        }
        if (nextId === "NOT_EVALUATED")
            return {
                error: "NOT_EVALUATED",
                blocked: true,
            };
        // overwrite nextId in specific case when vote is not apply in numeric question
        if (score_type === "numeric" && get(answer, "score", undefined) === null) {
            let questionId = undefined;
            rules.forEach((item) => {
                if (item.goto && !item.conditions) { // because rule is Always.
                    questionId = item.goto;
                    return;
                }
                item.conditions.forEach((condition) => {
                    if (condition.value === null) {
                        questionId = item.goto;
                    }
                });
            });
            if (questionId)
                nextId = questionId;
        }
        if (nextId !== undefined) {
            const nextItem = (_c = this.poll) === null || _c === void 0 ? void 0 : _c.sortedQuestions.find((item) => item.matchId ? item.matchId(nextId) : item.id === nextId);
            if (!nextItem) {
                console.log("smile-error: question id not found");
            }
            else if (nextItem.type === "thanks") {
                let item = (_d = this.poll.modules) === null || _d === void 0 ? void 0 : _d.find((item) => item.id === nextItem.id);
                const thanks = get(item, "metadata.thanks", {});
                set(thanks, "redes", get(item, "metadata.redes"));
                return {
                    error: "END",
                    isLast: true,
                    thanks,
                };
            }
            return {
                nextItem,
            };
        }
        if (!nextItem || nextItem.type === "thanks") {
            return {
                error: "END",
                isLast: true,
            };
        }
        return {
            nextItem,
        };
    }
    getScoreErrors({ answer, answers = [] }) {
        const response = answer || answers[this.index];
        const errors = [];
        const score = get(response, "score");
        if (this.type === "attachment" && !response.src) {
            errors.push(Object.assign(new Error("Invalid file"), {
                target: "attachment",
            }));
        }
        if (this.score_type === "smiles" && score === undefined)
            errors.push(Object.assign(new Error("Invalid score"), {
                target: "score",
            }));
        if (this.score_type === "radio" && score === undefined)
            errors.push(Object.assign(new Error("Invalid score"), {
                target: "score",
            }));
        if (this.score_type === "boolean" && score === undefined)
            errors.push(Object.assign(new Error("Invalid score"), {
                target: "score",
            }));
        if (this.score_type === "numeric" && score === undefined)
            errors.push(Object.assign(new Error("Invalid score"), {
                target: "score",
            }));
        if (this.score_type === "ces" && score === undefined)
            errors.push(Object.assign(new Error("Invalid score"), {
                target: "score",
            }));
        if (this.score_type === "csat" && score === undefined)
            errors.push(Object.assign(new Error("Invalid score"), {
                target: "score",
            }));
        return errors;
    }
    getCommentErrors({ answer, answers = [] }) {
        var _a;
        const response = (_a = (answer || answers[this.index])) !== null && _a !== void 0 ? _a : {};
        const errors = [];
        const { score_type } = this;
        const { commentEnabled, required } = this.metadata.settings;
        if (!score_type && commentEnabled && !response.comment)
            errors.push(Object.assign(new Error("Invalid comment"), {
                target: "comment",
            }));
        return errors;
    }
    getMotivesErrors({ answer, answers = [] }) {
        var _a;
        const response = (_a = (answer || answers[this.index])) !== null && _a !== void 0 ? _a : {};
        const errors = [];
        if (this.motives.length <= 1)
            return [];
        const responseMotives = get(response, "motives", get(response, "motives", []));
        responseMotives.forEach((motiveResponse) => {
            const motive = this.motives.find((motive) => motiveResponse.id === motive.id);
            if (get(motive, 'metadata.settings.showInput') && get(motive, 'metadata.settings.requiredInput', false) && motiveResponse.comment === null)
                errors.push(Object.assign(new Error("Invalid comment motive"), {
                    target: "motive",
                }));
        });
        if (this.motives.length > 1 &&
            responseMotives.length === 0 &&
            !(get(response, "score", undefined) === null))
            errors.push(Object.assign(new Error("Invalid motives"), {
                target: "motive",
            }));
        if (!this.metadata.settings.orderMotives) {
            if (responseMotives.length < this.metadata.settings.minMotivos)
                errors.push(Object.assign(new Error("Invalid min motives"), {
                    target: "motive",
                }));
            if (responseMotives.length > this.metadata.settings.maxMotivos)
                errors.push(Object.assign(new Error("Invalid max motives"), {
                    target: "motive",
                }));
        }
        return errors;
    }
    getErrors({ answer, answers = [], components = ["score", "motives", "comment"], }) {
        if (!this.isRequired)
            return [];
        const response = answer || answers[this.index];
        const errors = [
            ...(components.includes("score")
                ? this.getScoreErrors({ answer, answers })
                : []),
            ...(components.includes("motives")
                ? this.getMotivesErrors({ answer, answers })
                : []),
            ...(components.includes("comment")
                ? this.getCommentErrors({ answer, answers })
                : []),
        ];
        // if (this.type === "form") {
        //   const requiredFields = get(response, "userContactData", []).filter(
        //     (field: any) => field.required
        //   );
        //   if (requiredFields === 0) return errors;
        //   const error = requiredFields.every((field: any) => !field.response);
        //   if (error) {
        //     errors.push(
        //       Object.assign(new Error("Complete field required"), {
        //         target: "form",
        //       })
        //     );
        //   }
        // }
        if (this.type === "store" && !get(response, "store_key"))
            errors.push(Object.assign(new Error("Store is required"), {
                target: "store",
            }));
        return errors;
    }
    isResponseValid(answers) {
        const errors = this.getErrors({ answers });
        return errors.length === 0;
    }
    get components() {
        const components = [];
        const commentEnabled = get(this.metadata.settings, "commentEnabled", false);
        if (this.score_type !== null) {
            components.push("score");
        }
        if (this.motives.length > 1) {
            components.push("motives");
        }
        if (commentEnabled) {
            components.push("comment");
        }
        return components;
    }
    isStepable(answers) {
        const next = this.getNext(answers);
        if (next.isLast)
            return 1;
        const isOrderMotives = this.metadata.settings.orderMotives;
        if (isOrderMotives)
            return 1;
        if (!this.isRequired) {
            const answer = answers[this.index];
            const validation = [
                ...this.getScoreErrors({ answer, answers }),
                ...this.getMotivesErrors({ answer, answers }),
                ...this.getCommentErrors({ answer, answers }),
            ];
            if (this.type === 'store' && get(answer, 'store_key', null) === null)
                validation.push({
                    name: 'store',
                    message: 'Store question not required with autostep',
                    target: 'store'
                });
            if (validation.length !== 0)
                return 1;
        }
        const maxMotives = this.metadata.settings.maxMotivos;
        const { commentEnabled } = this.metadata.settings;
        const hasMotiveWithInput = this.motives.length > 0
            ? this.motives.reduce((reduced, motive) => reduced +
                (get(motive, "metadata.settings.showInput", false) ? 1 : 0), 0)
            : null;
        // Stop autoStep
        if (commentEnabled)
            return 1;
        //find Index
        const index = answers.findIndex((answer) => answer.module.id === this.id);
        if (get(answers[index], "dirty") &&
            !get(answers[index], "score") &&
            this.score_type !== null)
            return 0;
        const numberOfMotiveSelected = get(answers[index], "motives", []).length;
        if (numberOfMotiveSelected === maxMotives) {
            const lastMotive = answers[index].motives[numberOfMotiveSelected - 1].id;
            const motiveIndex = this.motives.findIndex((item) => item.id === lastMotive);
            if (get(this, `motives[${motiveIndex}].metadata.settings.showInput`, false) === false) {
                return 0;
            }
        }
        // Conditions for consider not stepable question
        if (maxMotives > 1 || commentEnabled || hasMotiveWithInput > 0) {
            return 1;
        }
        return 0;
    }
    getGroup() {
        return this.metadata.settings.group;
    }
    getLayout() {
        return this.metadata.settings.layout;
    }
    getStyle() {
        return {
            style: {
                fontSize: get(this.metadata.settings, "fontSize"),
                // color: get(this, "metadata.settings.color", "#262626")
            },
        };
    }
    getDescriptionStyle() {
        return {
            style: {
                fontSize: get(this, "metadata.settings.descriptionSize", get(this.metadata.settings, "fontSize")),
                // color: get(this, "metadata.settings.color", "#262626")
            },
        };
    }
    getSubModules() {
        return [this];
    }
    getScoreLabels() {
        // const scoreSettings = this.metadata.settings.score;
        const isReversed = this.isReversed();
        const options = this.getScoreOptions();
        const firstIndex = isReversed ? options.length - 1 : 0;
        const lastIndex = isReversed ? 0 : options.length - 1;
        const { showLabels, best: firstLabel = options[firstIndex].label, worst: lastLabel = options[lastIndex].label, } = this.metadata.settings.score;
        return [
            showLabels ? firstLabel : undefined,
            showLabels ? lastLabel : undefined,
        ];
    }
    isReversed() {
        const scoreSettings = this.metadata.settings.score;
        const { layout: scoreLayout, order } = scoreSettings;
        if (["rate"].includes(scoreLayout)) {
            return false;
        }
        // if (['smiles', 'boolean'].includes(scoreLayout)) {
        //   return !['descend', 'reverse'].includes(order);
        // }
        return ["descend", "reverse"].includes(order);
    }
    getScoreOptions({ ignoreSettings = false, theme } = {}) {
        var _a;
        const scoreSettings = this.metadata.settings.score;
        const { layout: scoreLayout, scale: scoreScale } = scoreSettings;
        const { min, max } = scoreSettings;
        const labels = [...((_a = scoreSettings.labels) !== null && _a !== void 0 ? _a : [])];
        const reversed = this.isReversed();
        // if (reversed && this.score_type !== 'boolean') labels.reverse();
        const { scores: themeScores, smiles: themeSmiles } = theme !== null && theme !== void 0 ? theme : {};
        const layoutTemplateKey = `${scoreLayout}_${min}_${max}`;
        const scaleTemplateKey = `${scoreScale}_${min}_${max}`;
        const layoutTemplate = get(constants_1.layoutTemplates, layoutTemplateKey);
        const scaleTemplate = get(constants_1.scaleTemplates, scaleTemplateKey);
        const options = [];
        const defaultLayout = (() => {
            if (scoreLayout === "smiles")
                return "image";
            if (scoreLayout === "buttons")
                return "button";
            return "option";
        })();
        for (let i = 0; i <= max - min; i++) {
            const score = (i * 9) / (max - min) + 1;
            const layoutKey = layoutTemplate === null || layoutTemplate === void 0 ? void 0 : layoutTemplate[i];
            const scaleKey = scaleTemplate === null || scaleTemplate === void 0 ? void 0 : scaleTemplate[i];
            const layout = (() => {
                return defaultLayout;
            })();
            const label = (() => {
                if (scoreLayout === "numeric")
                    return min + i;
                if (labels.length === max && labels[i])
                    return labels[i];
                if (scaleKey) {
                    const i18nLabel = get(constants_1.keyToI18n, [scaleKey], scaleKey);
                    if (i18nLabel)
                        return this.t(i18nLabel);
                    return scaleKey;
                }
                return String(min + i);
            })();
            const option = {
                id: i + 1,
                score,
                layout,
                imageSrc: themeSmiles ? themeSmiles[score].src : undefined,
                key: layoutKey !== null && layoutKey !== void 0 ? layoutKey : `${scoreLayout}-${String(score)}`,
                label,
            };
            if (get(constants_1.keyToEmoji, [layoutKey]))
                Object.assign(option, {
                    emoji: get(constants_1.keyToEmoji, [layoutKey]),
                });
            options.push(option);
        }
        if (ignoreSettings)
            return options;
        const sorted = reversed ? options.reverse() : options;
        if (this.metadata.settings.allowScoreNA)
            sorted.push({
                id: 0,
                score: null,
                label: "N/A",
                layout: defaultLayout,
                imageSrc: undefined,
                key: `${scoreLayout}-na`,
                emoji: get(constants_1.keyToEmoji, ["score-na"]),
            });
        return sorted;
    }
    getTitle() {
        return this.title;
    }
    getMotivesTitle() {
        const title = this.t(this.metadata.strings.motivosTitle, this.metadata.strings.motivosTitle);
        if (title)
            return title;
    }
    isValid({ answers, components, }) {
        const errors = this.getErrors({ answers, components });
        return errors.length === 0;
    }
    getScoreFromValue(value) {
        if (this.score_type === null)
            return;
        const scoreSettings = this.metadata.settings.score;
        const { min, max } = scoreSettings;
        if (value < min || value > max)
            return;
        return ((value - min) * 9) / (max - min) + 1;
    }
}
exports.default = Module;
